import React from 'react';
import styled from 'styled-components';
import { AreaChart, Area, ResponsiveContainer } from 'recharts';
import Draggable from 'react-draggable';
import C from '../../../Constant';
import { wait, isMobile, Event, encode, getUID, decode } from "../../../Helper";
import storage from "../../../Storage";
import socket from '../../../Socket';
import Engine from "./Engine";
const PopupWrapper = styled.div`
  position: absolute;
  top: 10px;
  right: 10px;
  z-index: 1000;
`;

const PopupContainer = styled.div`
  background-color: #292d2e;
  border-radius: 8px;
  padding: 5px 10px;
  width: 270px;
  color: white;
  font-family: Arial, sans-serif;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  cursor: move;
`;

const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
`;

const Title = styled.h2`
  font-size: 18px;
  font-weight: bold;
  text-align: center;
  color: #49BC0D;
`;

const InnerContainer = styled.div`
  background-color: #292d2e;
  border-radius: 12px;
  padding: 10px;
`;

const CloseButton = styled.button`
  background: none;
  border: none;
  color: #777;
  font-size: 18px;
  cursor: pointer;
`;

const BetInfo = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 16px;
  padding: 0 12px;
`;

const InfoColumn = styled.div`
  display: flex;
  flex-direction: column;
`;

const Label = styled.span`
  font-size: 14px;
  color: #777;
  margin-bottom: 4px;
`;

const Value = styled.span`
  font-size: 13px;
  font-weight: bold;
`;

const GraphContainer = styled.div`
  height: 150px;
  margin-bottom: 16px;
`;

const WinLoseInfo = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 0 12px;
  margin-top: 4px;
`;

class BetsPopCrash extends React.Component {
  constructor(props) {
    super(props);
    this._isMounted = false;
    this.state = {
      profit: 0.00000000,
      engine: new Engine(),
      wins: 0,
      losses: 0,
      data: [{ value: 0 }],
      userData: null
    };
  }

  componentDidMount() {
    this._isMounted = true;
    const { engine } = this.state;
    
    if (engine) {
      socket.on(C.PLAY_CRASH, this.handlePlay);
      socket.on(C.BUSTED_CRASH, this.handleBusted);
      socket.on(C.ERROR_CRASH, this.handleError);
    }
    socket.on(C.USER_INFO, this.handleUserInfo);
    this.requestUserInfo();
  }

  componentWillUnmount() {
    this._isMounted = false;
    const { engine } = this.state;
    
    if (engine) {
        socket.off(C.PLAY_CRASH, this.handlePlay);
        socket.off(C.BUSTED_CRASH, this.handleBusted);
        socket.off(C.ERROR_CRASH, this.handleError);
    }
    socket.off(C.USER_INFO, this.handleUserInfo);
  }

  requestUserInfo = () => {
    socket.emit(C.USER_INFO, encode({
      id: getUID,
      coin: storage.getKey('coin') || '',
      rate: null,
      game: 'all',
      first: true
    }));
  };

  handleUserInfo = (data) => {
    const decodedData = decode(data);
    console.log("User info received:", decodedData);
    if (decodedData.status) {
      this.setState({ userData: decodedData });
    }
  };

  handlePlay = (data) => {
    if (this._isMounted && data) {
      console.log("Play data received:", data);
    }
  }

  handleBusted = (data) => {
    const decodedData = decode(data);
    if (this._isMounted && decodedData) {
      
      let newProfit = 0; // Initialize profit
      const { players, winners } = decodedData;
      const userUid = this.state.userData.id; // Assuming user data has uid
  
      // Check if the user has placed a bet by looking for the user in the players array
      const player = players.find(player => player.uid === userUid);
      
      if (!player && !winners.find(winner => winner.uid === userUid)) {
        // If the user hasn't placed a bet or isn't in winners, don't handle anything
        console.log("No bet placed by the user or no winnings, skipping profit calculation.");
        return;
      }
  
      // Check if the user is a winner
      const winner = winners.find(winner => winner.uid === userUid);
      
      if (winner) {
        // User is in winners, profit is the won amount
        const wonAmount = parseFloat(winner.won);
        newProfit = wonAmount; // Profit is directly the won amount
      } else {
        // User placed a bet but is not a winner, calculate loss
        const betAmount = parseFloat(player.amount);
        newProfit = -betAmount; // Loss equals the negative of the bet amount
      }
  
      // Update state with new profit, wins, losses, and data points
      this.setState(prevState => {
        const currentProfit = parseFloat(prevState.profit);
        const totalProfit = (currentProfit + newProfit).toFixed(8); // Update total profit
        const wins = newProfit > 0 ? prevState.wins + 1 : prevState.wins;
        const losses = newProfit <= 0 ? prevState.losses + 1 : prevState.losses;
  
        const newDataPoint = { value: parseFloat(totalProfit) };
        const updatedData = [...prevState.data, newDataPoint].slice(-20); // Keep last 20 data points
  
        console.log("Busted data received:", decodedData);
        console.log("New data point:", newDataPoint);
        console.log("Updated data:", updatedData);
  
        this.requestUserInfo(); // Assuming you have this function to refresh user data
        return {
          profit: totalProfit,
          wins,
          losses,
          data: updatedData
        };
      });
    }
  };
  
  
  handleError = (error) => {
    console.error("Keno game error:", error);
  }

  handleClose = (e) => {
    e.preventDefault();
    e.stopPropagation();
    this.props.onClose();
  };

  render() {
    const { profit, wins, losses, data, userData } = this.state;

    console.log("data win games is", data)
    const profitNum = parseFloat(profit) || 0;
    const isWinning = profitNum > 0;
    const graphColor = isWinning ? '#67B699' : '#d9534f';

    return (
      <Draggable bounds="parent">
        <PopupWrapper>
          <PopupContainer>
            <Header>
              <Title>Live Stats</Title>
              <CloseButton onClick={this.handleClose}>×</CloseButton>
            </Header>

            <InnerContainer>
              <BetInfo>
                <InfoColumn>
                  <Label>Wagered</Label>
                  <Value>{userData?.profit || '0.00000000'}</Value>
                </InfoColumn>
                <InfoColumn>
                  <Label>Profit</Label>
                  <Value style={{ color: graphColor }}>
                    {profitNum > 0 ? '+' : ''}{profitNum.toFixed(8)}
                  </Value>
                </InfoColumn>
              </BetInfo>
              
              <GraphContainer>
                <ResponsiveContainer width="100%" height="100%">
                  <AreaChart data={data}>
                    <Area
                      type="linear"
                      dataKey="value"
                      stroke={graphColor}
                      fill={graphColor}
                      fillOpacity={0.6}
                      isAnimationActive={false}
                    />
                  </AreaChart>
                </ResponsiveContainer>
              </GraphContainer>
            </InnerContainer>
            
            <WinLoseInfo>
              <InfoColumn>
                <Label>Win</Label>
                <Value style={{ color: isWinning ? '#67B699' : 'inherit' }}>{wins}</Value>
              </InfoColumn>
              <InfoColumn>
                <Label>Lose</Label>
                <Value style={{ color: !isWinning ? '#d9534f' : 'inherit' }}>{losses}</Value>
              </InfoColumn>
            </WinLoseInfo>
          </PopupContainer>
        </PopupWrapper>
      </Draggable>
    );
  }
}

export default BetsPopCrash;


// import React from 'react';
// import styled from 'styled-components';
// import { AreaChart, Area, ResponsiveContainer, YAxis } from 'recharts';
// import C from '../../../Constant';
// import { decode } from "../../../Helper";
// import socket from '../../../Socket';

// const GraphWrapper = styled.div`
//   width: 100%;
//   height: 300px;
//   background-color: #292d2e;
//   border-radius: 8px;
//   padding: 16px;
//   margin-bottom: 16px;
// `;

// const CurrentMultiplier = styled.div`
//   font-size: 24px;
//   font-weight: bold;
//   color: #49BC0D;
//   text-align: center;
//   margin-bottom: 8px;
// `;

// class CrashGameGraph extends React.Component {
//   constructor(props) {
//     super(props);
//     this.state = {
//       data: [{ multiplier: 1 }],
//       currentMultiplier: 1,
//       isGameActive: false,
//       maxMultiplier: 1,
//     };
//     this.graphUpdateInterval = null;
//   }

//   componentDidMount() {
//     socket.on(C.STARTED_CRASH, this.handleGameStart);
//     socket.on(C.BUSTED_CRASH, this.handleGameEnd);
//     socket.on('payout_updated', this.handlePayoutUpdate);
//   }

//   componentWillUnmount() {
//     socket.off(C.STARTED_CRASH, this.handleGameStart);
//     socket.off(C.BUSTED_CRASH, this.handleGameEnd);
//     socket.off('payout_updated', this.handlePayoutUpdate);
//     this.stopGraphUpdate();
//   }

//   handleGameStart = (data) => {
//     const decodedData = decode(data);
//     console.log("Game started:", decodedData);
//     this.setState({
//       data: [{ multiplier: 1 }],
//       currentMultiplier: 1,
//       isGameActive: true,
//       maxMultiplier: 1,
//     }, this.startGraphUpdate);
//   }

//   handleGameEnd = (data) => {
//     const decodedData = decode(data);
//     console.log("Game ended:", decodedData);
//     this.setState({ isGameActive: false }, this.stopGraphUpdate);
//   }

//   handlePayoutUpdate = (multiplier) => {
//     console.log("Payout updated:", multiplier);
//     this.setState(prevState => ({
//       currentMultiplier: multiplier,
//       maxMultiplier: Math.max(prevState.maxMultiplier, multiplier),
//     }));
//   }

//   startGraphUpdate = () => {
//     this.graphUpdateInterval = setInterval(() => {
//       this.setState(prevState => {
//         const newMultiplier = prevState.currentMultiplier + 0.01;
//         const newDataPoint = { multiplier: newMultiplier };
//         const newData = [...prevState.data, newDataPoint].slice(-100); // Keep last 100 points
//         return {
//           data: newData,
//           currentMultiplier: newMultiplier,
//           maxMultiplier: Math.max(prevState.maxMultiplier, newMultiplier),
//         };
//       });
//     }, 100); // Update every 100ms
//   }

//   stopGraphUpdate = () => {
//     if (this.graphUpdateInterval) {
//       clearInterval(this.graphUpdateInterval);
//       this.graphUpdateInterval = null;
//     }
//   }

//   render() {
//     const { data, currentMultiplier, maxMultiplier } = this.state;

//     return (
//       <GraphWrapper>
//         <CurrentMultiplier>{currentMultiplier.toFixed(2)}x</CurrentMultiplier>
//         <ResponsiveContainer width="100%" height="100%">
//           <AreaChart data={data}>
//             <defs>
//               <linearGradient id="colorMultiplier" x1="0" y1="0" x2="0" y2="1">
//                 <stop offset="5%" stopColor="#49BC0D" stopOpacity={0.8}/>
//                 <stop offset="95%" stopColor="#49BC0D" stopOpacity={0}/>
//               </linearGradient>
//             </defs>
//             <YAxis
//               domain={[1, maxMultiplier => Math.max(maxMultiplier * 1.1, 2)]}
//               hide
//             />
//             <Area
//               type="monotone"
//               dataKey="multiplier"
//               stroke="#49BC0D"
//               fillOpacity={1}
//               fill="url(#colorMultiplier)"
//               isAnimationActive={false}
//             />
//           </AreaChart>
//         </ResponsiveContainer>
//       </GraphWrapper>
//     );
//   }
// }

// export default CrashGameGraph;